import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { CONVERSION_COLORS } from 'pages/Monitoring/OrderConversion/OrderConversionList/constants/conversionColors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TranslationKey } from 'providers/i18n/types';
import { useRecordContext } from 'react-admin';
import { Bar } from 'react-chartjs-2';
import { Chip } from 'shared/mui/Chips';
import { Tooltip as TooltipMui } from 'shared/mui/Tooltip';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { GatewayConversionListItem } from 'types/embedded/orderConversion';

import { defaultOptions } from './config/defaultOptions';
import {
  ChartWrapperStyled,
  LegendWrapperStyled,
  WrapperStyled,
} from './OrderConversionListDatagridConversionField.styled';
import { OrderConversionListDatagridConversionFieldLegend } from './OrderConversionListDatagridConversionFieldLegend/OrderConversionListDatagridConversionFieldLegend';
import { TooltipTitleStyled } from './OrderConversionListDatagridConversionFieldLegend/OrderConversionListDatagridConversionFieldLegend.styled';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
);

type Props = Omit<FunctionFieldProps, 'render'>;

export const OrderConversionListDatagridConversionField: React.FC<Props> = (props) => {
  const translate = useTypedTranslate();
  const record = useRecordContext<GatewayConversionListItem>();

  const datasets = record
    ? record?.conversionItems.map((item) => {
        return {
          label: translate(`app.statuses.${[item.label]}` as TranslationKey),
          data: [{ x: item.value, count: item.count }],
          backgroundColor: CONVERSION_COLORS[item.label],
        };
      })
    : [];

  const data: ChartData<'bar', { x: number; count: number }[], string> = {
    labels: [''],
    datasets,
  };

  return (
    <FunctionField
      render={() => (
        <WrapperStyled>
          <ChartWrapperStyled>
            <Bar data={data} options={defaultOptions} style={{ borderRadius: '4px' }} />
          </ChartWrapperStyled>
          <LegendWrapperStyled>
            <OrderConversionListDatagridConversionFieldLegend data={data} />
            {record && record?.messages?.length > 0 && (
              <TooltipMui
                title={
                  <TooltipTitleStyled>
                    {record?.messages.map((message, index) => (
                      <span key={index}>{message}</span>
                    ))}
                  </TooltipTitleStyled>
                }
              >
                <Chip
                  color="warning"
                  icon={<InfoOutlinedIcon />}
                  label={translate('app.orderConversion.deviations')}
                  state="default"
                />
              </TooltipMui>
            )}
          </LegendWrapperStyled>
        </WrapperStyled>
      )}
      {...props}
    />
  );
};
